import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Dialog, Button } from 'react-toolbox';
import FlexBox from 'flexbox-react';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { updatePhaseTask, clearValidationErrors } from 'actionCreators';
import CompleteTaskModal from 'CompleteTaskModal';
import TaskIcon from 'components/TaskIcon';
import { urls } from 'helpers/url';
import modalStyles from 'modal.scss';
import S from '../phaseTask.scss';
import { RAILS_DATE } from 'config/constants';

export default class PhaseTask extends React.Component {
  state = { modalActive: false, errorModalActive: false };

  onClick = () => this.setState({ modalActive: true });

  handleClose = () => {
    this.props.handleTasksClose();
    this.setState({ modalActive: false });
  }

  isDisabled = () => this.props.task.status !== 'incomplete';

  determineIsMissingApptError = (errorModalActive, errors, errorSources) => (
    errorModalActive &&
    errorSources.length === 1 &&
    errors[errorSources[0]].length === 1 &&
    errors[errorSources[0]][0] === 'At least one appointment must be scheduled before completing this task'
  );

  determineIsBuildDateError = (errorModalActive, errors, errorSources) => (
    errorModalActive &&
    errorSources.length === 1 &&
    errors[errorSources[0]].length === 1 &&
    errors[errorSources[0]][0] === 'Verify build date flag is still present. Please resolve before completing this task.'
  );

  preSubmitMissingApptError = () => {
    const { phase: { appointments = [] }, task: { slug } } = this.props;
    return slug === 'installation_customer_review' &&
      (!appointments.length || !appointments.some(a => a.kind === 'installation' &&
        moment(a.start_date, RAILS_DATE).isAfter(moment())));
  }

  toggleStatus = () => this.props.updatePhaseTask(
    this.props.phase.id,
    this.props.task.slug,
    { task: { status: this.props.task.status === 'complete' ? 'incomplete' : 'complete' } },
  );

  completeTask = () => {
    this.props.updatePhaseTask(
      this.props.phase.id,
      this.props.task.slug,
      { task: { status: 'complete' } },
    ).catch(() => this.setState({ errorModalActive: true }));
    this.childHandleTasksClose();
  }

  childHandleTasksClose = () => this.props.handleTasksClose();

  handleErrorClose = () => {
    this.setState({ errorModalActive: false });
    this.props.clearValidationErrors('PHASE');
  }

  renderErrorMessage = (name, errors, errorSources) => <h5
    className={modalStyles.errorMessage}
  >
    Cannot complete {name} task:{' '}
    {errorSources.map(resource =>
      [].concat(errors[resource]).join(', ')).join(', ')}
  </h5>

  renderErrorDialog = () => {
    const { errorModalActive } = this.state;
    const { phase, phase: { errors }, task: { name } } = this.props;
    const errorSources = Object.keys(errors) || {};
    const isMissingApptError = this.determineIsMissingApptError(
      errorModalActive, errors, errorSources,
    );
    const isVerifyBuildDateError = this.determineIsBuildDateError(
      errorModalActive, errors, errorSources,
    );
    return (<Dialog
      active={errorModalActive}
      className={modalStyles.modal}
      type="fullscreen"
      onEscKeyDown={this.handleErrorClose}
      onOverlayClick={this.handleErrorClose}
    >
      {this.renderErrorMessage(name, errors, errorSources)}
      {isMissingApptError && (<FlexBox justifyContent="center">
        <Link
          to={urls.phaseAppointments(phase)}
          className={modalStyles.linkButton}
          onClick={this.handleErrorClose}
        >Schedule Appointment</Link>
      </FlexBox>)}
      {isVerifyBuildDateError && (<FlexBox justifyContent="center">
        <Button
          label="OK"
          flat inverse ripple
          className={modalStyles.action}
          onClick={this.handleErrorClose}
        />
      </FlexBox>)}
      {!isMissingApptError && !isVerifyBuildDateError && (<Button
        label="OK"
        flat inverse ripple
        className={modalStyles.action}
        onClick={this.handleErrorClose}
      />)}
    </Dialog>);
  }

  renderChildren = () => <CompleteTaskModal
    phase={this.props.phase}
    task={this.props.task}
    active={this.state.modalActive}
    completeTask={this.completeTask}
    onClose={this.handleClose}
    updatePhaseTask={this.props.updatePhaseTask}
    childHandleTasksClose={this.childHandleTasksClose}
  />

  render = () => {
    const { task: { name, status } } = this.props;
    const preSubmitApptDisabled = this.preSubmitMissingApptError();
    return (<div className={S.taskContainer}>
      <TaskIcon status={status} />
      <button
        className={preSubmitApptDisabled ? S.taskButtonBlocked : S.taskButton}
        onClick={this.onClick}
        disabled={preSubmitApptDisabled || this.isDisabled()}
      >{`${name}${preSubmitApptDisabled ? ' (Requires Pending Installation Appointment)' : ''}`}</button>
      {this.renderChildren()}
      {this.renderErrorDialog()}
    </div>);
  }
}

PhaseTask.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  clearValidationErrors: PropTypes.func.isRequired,
  handleTasksClose: PropTypes.func.isRequired,
};

export const phase_task = connect(() => ({}), {
  updatePhaseTask,
  clearValidationErrors,
})(PhaseTask);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/phase_task.jsx